import type { FC } from 'react';
import { Text, Button } from '@livechat/design-system-react-components';

import Amplitude from 'services/Amplitude';

import * as styles from './styles';

type Props = {
  email: string;
  disabled: boolean;
  loading: boolean;
  handleSendVerification: () => void;
};

export const SendAgain: FC<Props> = ({ email, disabled, loading, handleSendVerification }) => {
  const handleResendClick = () => {
    handleSendVerification();
    Amplitude.logEvent(email, 'RESEND_VERIFICATION_EMAIL_CLICK');
  };

  return (
    <div css={styles.bottomTextContainer} data-testid="stop-screen-bottom-text-container">
      <div css={styles.bottomText}>
        <Text>
          Didn&#39;t get an email? Check your <b>spam folder</b>
        </Text>
        <Text>
          or{' '}
          <Button
            kind="link-light"
            css={styles.button(disabled)}
            onClick={handleResendClick}
            disabled={disabled}
            loading={loading}
          >
            get a new confirmation code
          </Button>
          .
        </Text>
      </div>
      <Text>
        <Button
          kind="link-light"
          href={import.meta.env.VITE_APP_HC_VERIFICATION}
          target="_blank"
          rel="noopener noreferrer"
          css={styles.button(false)}
        >
          Visit Help Center
        </Button>{' '}
        to learn more.
      </Text>
    </div>
  );
};
